export const EMAIL_LINK = "mailto:mtojong@gmail.com";
export const GITHUB_LINK = "https://github.com/mtojong246";
export const LINKEDIN_LINK = "https://www.linkedin.com/in/melanie-tojong-4b5149158/";

export const PLACEHOLDER_LINK = "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png";
